module.exports = __webpack_public_path__ + "static/media/IMAGEN-PHYSICIANS-JOURNEY.d80944db.png";